import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { categories } from '@/mocks/anime';

const categoryImages: Record<string, string> = {
  mystery: 'https://readdy.ai/api/search-image?query=Dark%20mysterious%20library%20with%20candlelight%2C%20old%20books%20and%20a%20magnifying%20glass%20on%20a%20wooden%20table%2C%20warm%20amber%20lighting%2C%20Victorian%20aesthetic%2C%20shallow%20depth%20of%20field%2C%20moody%20atmosphere&width=600&height=400&seq=cat-mystery&orientation=landscape',
  scifi: 'https://readdy.ai/api/search-image?query=Futuristic%20cityscape%20with%20floating%20holographic%20displays%2C%20sleek%20glass%20towers%2C%20warm%20sunset%20light%20reflecting%20on%20buildings%2C%20clean%20minimalist%20sci-fi%20aesthetic%2C%20atmospheric%20haze&width=600&height=400&seq=cat-scifi&orientation=landscape',
  psychological: 'https://readdy.ai/api/search-image?query=Abstract%20psychological%20portrait%2C%20fragmented%20mirror%20reflections%2C%20dim%20ambient%20lighting%2C%20deep%20shadows%20and%20highlights%2C%20surreal%20atmosphere%2C%20emotional%20tension%2C%20minimalist%20composition&width=600&height=400&seq=cat-psych&orientation=landscape',
  romance: 'https://readdy.ai/api/search-image?query=Cherry%20blossom%20petals%20falling%20on%20a%20quiet%20riverside%20path%20at%20golden%20hour%2C%20two%20silhouettes%20in%20the%20distance%2C%20warm%20soft%20lighting%2C%20romantic%20atmosphere%2C%20dreamy%20bokeh%20effect&width=600&height=400&seq=cat-romance&orientation=landscape',
  action: 'https://readdy.ai/api/search-image?query=Dynamic%20action%20scene%20silhouette%20with%20dramatic%20lighting%2C%20a%20figure%20mid-leap%20against%20a%20blazing%20sunset%20sky%2C%20motion%20blur%20effects%2C%20cinematic%20composition%2C%20warm%20golden%20and%20crimson%20tones&width=600&height=400&seq=cat-action&orientation=landscape',
  historical: 'https://readdy.ai/api/search-image?query=Ancient%20Japanese%20castle%20silhouette%20at%20sunset%2C%20traditional%20architecture%2C%20misty%20mountains%20in%20background%2C%20warm%20golden%20hour%20light%2C%20historical%20atmosphere%2C%20serene%20and%20majestic&width=600&height=400&seq=cat-historical&orientation=landscape',
};

export default function CategoryNav() {
  const { t } = useTranslation();

  return (
    <section id="categories" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            {t('section.categories')}
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            {t('section.categories.desc')}
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group relative rounded-lg overflow-hidden h-[200px] md:h-[240px]"
            >
              <img
                src={categoryImages[cat.slug] || ''}
                alt={cat.name}
                className="absolute inset-0 w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/30 to-black/20"></div>
              <div className="absolute inset-0 flex flex-col items-center justify-center text-center p-3">
                <div className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center mb-2">
                  <i className={`${cat.icon} text-2xl md:text-3xl text-accent-400`}></i>
                </div>
                <h3 className="text-sm md:text-base font-heading font-bold text-background-50 whitespace-nowrap">
                  {cat.name}
                </h3>
                <p className="text-xs text-foreground-200 mt-1 hidden sm:block">
                  {cat.description}
                </p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}